import FullScreenDialog, { FullScreenDialogCloseReason } from "../../components/full-screen-dialog/FullScreenDialog";
import { bindDialog, BindDialogReturn, DialogProps, DialogResult, DialogState, useDialogState } from "../../hooks/use-dialog-state/UseDialogState";
import AlarmSetpointEditor from "./AlarmSetpointEditor";

import type { JSX } from "react";

export type AlarmSetpointEditorDialogInitValues = {
    groupID: number;
    setpointID: number;
    organizationID: number;
    copy?: boolean;
    objectName?: string;
    tagName?: string;
    tagID?: number;
};

export type AlarmSetpointEditorDialogResultValues = {
    setpointID: number | undefined;
};

export type AlarmSetpointEditorDialogResultReason = FullScreenDialogCloseReason | "cancel" | "save";

export type AlarmSetpointEditorDialogResult = DialogResult<AlarmSetpointEditorDialogResultValues, AlarmSetpointEditorDialogResultReason>;

export type AlarmSetpointEditorDialogProps = DialogProps<AlarmSetpointEditorDialogInitValues, AlarmSetpointEditorDialogResult>;

export default function AlarmSetpointEditorDialog({
    open,
    onClose,
    values
}: AlarmSetpointEditorDialogProps): JSX.Element {

    return (
        <FullScreenDialog open={open} onClose={reason => onClose({ reason: reason })}>
            <AlarmSetpointEditor
                groupID={values?.groupID as number}
                setpointID={values?.setpointID}
                onClose={({
                    reason, 
                }) => onClose({
                    reason: reason,
                    values: {
                        setpointID: values?.setpointID
                    }
                })}
                copy={values?.copy}
                objectName={values?.objectName}
                tagName={values?.tagName}
                tagID={values?.tagID}
            />
        </FullScreenDialog>
    );
}

export type AlarmSetpointEditorDialogState = DialogState<AlarmSetpointEditorDialogInitValues, AlarmSetpointEditorDialogResult>;
export type BindAlarmSetpointEditorDialogReturn = BindDialogReturn<AlarmSetpointEditorDialogInitValues, AlarmSetpointEditorDialogResult>;

export function useAlarmSetpointEditorDialogState(): AlarmSetpointEditorDialogState {
    return useDialogState();
}

export function bindAlarmSetpointEditorDialog(props: AlarmSetpointEditorDialogState): BindAlarmSetpointEditorDialogReturn {
    return bindDialog(props);
}
